var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.195251 10.7986C-0.065083 10.5301 -0.0650829 10.0948 0.195251 9.82636L4.39052 5.49999L0.195252 1.17361C-0.0650821 0.905146 -0.0650821 0.46982 0.195252 0.201352C0.455586 -0.0671182 0.87772 -0.0671181 1.13805 0.201352L5.80474 5.01386C5.92976 5.14277 6 5.31767 6 5.49999C6 5.68232 5.92976 5.85722 5.80474 5.98612L1.13805 10.7986C0.877719 11.0671 0.455585 11.0671 0.195251 10.7986Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.649a76b073b313a88f21b4097c4473ce.svg";
export { ForwardRef as ReactComponent };